import {errorMessages, ErrorState,UserRegistrationForm,Validator} from "./registrationFormHook";
import {useRegistrationStyles} from "./registrationStyles";
import {Box, Grid, MenuItem, Select, TextField} from "@material-ui/core";
import {FormControlContainer} from "./FormControlContainer";
import {RegistrationLookups} from "../../services/medicationmanagement/userRegistration/RegistrationLookups";
import {KeyboardDatePicker} from "@material-ui/pickers";
import React from "react";
import {MaterialUiPickersDate} from "@material-ui/pickers/typings/date";
import {ApplicationDatePicker} from "./ApplicationDatePicker";


export const PharmacistRegistrationForm=(props:{
    lookUps:RegistrationLookups;
    registerControl:(field:keyof UserRegistrationForm,value:string|null,validator?:Validator|'Required')=>any,
    errors:ErrorState
})=>{
    let {lookUps,errors}=props;
    let classes=useRegistrationStyles();
    let requiredMessage = errorMessages.get('Required');
    return (
        <>
            
                <FormControlContainer hasError={()=>errors.firstName} label="First name/given name" id="firstName" errorMessage={requiredMessage}>
                    <TextField
                        required
                        placeholder=""
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        {...props.registerControl('firstName','','Required')}
                    />
                </FormControlContainer>
                <FormControlContainer hasError={()=>errors.lastName} label="Last name/surname" id="lastName" errorMessage={requiredMessage}>
                    <TextField
                        required
                        placeholder=""
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        {...props.registerControl('lastName','','Required')}
                    />
                </FormControlContainer>
                <FormControlContainer hasError={()=>errors.gender} label="Gender/sex" errorMessage={requiredMessage} id="gender">
                    <Select
                        {...props.registerControl('gender','','Required')}
                    >
                        <MenuItem value="">Select gender/ sex</MenuItem>
                        {props.lookUps.genders.filter(x=>x.code!=='U').map(x=><MenuItem key={x.code} value={x.code||''}>{x.name}</MenuItem>)}
                    </Select>
                </FormControlContainer>
                <FormControlContainer hasError={()=>errors.dateOfBirth} label="Date of birth" errorMessage={requiredMessage} id="dateOfBirth">
                    <ApplicationDatePicker disableFuture={true} {...props.registerControl('dateOfBirth',null,'Required')}/>
                </FormControlContainer>
                <FormControlContainer hasError={()=>errors.email} label="Email address" errorMessage={requiredMessage} id="email">
                    <TextField
                        required
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        {...props.registerControl('email','','Required')}
                    />
                </FormControlContainer>
                <FormControlContainer hasError={()=>errors.phoneLocal || errors.phoneArea} label="Phone  (area - local)" errorMessage={requiredMessage} id="phone">
                    <Grid container spacing={1}>
                        <Grid item xs={4}>
                            <TextField
                                placeholder=""
                                fullWidth
                                margin="normal"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                {...props.registerControl('phoneArea','','Required')}
                            />
                        </Grid>
                        <Grid item xs={8}>
                            <TextField
                                placeholder=""
                                fullWidth
                                margin="normal"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                {...props.registerControl('phoneLocal','','Required')}
                            />
                        </Grid>

                    </Grid>
                </FormControlContainer>
                <FormControlContainer label="Aged care organisation name" hasError={()=>errors.organisationName}  errorMessage={requiredMessage} id="organisationName">
                    <TextField
                        placeholder=""
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        {...props.registerControl('organisationName','','Required')}
                        />
                </FormControlContainer>
            <FormControlContainer label="Aged care facility name" hasError={() => errors.facilityName} errorMessage={requiredMessage} id="facilityName">
                <TextField
                    placeholder=""
                    fullWidth
                    margin="normal"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    {...props.registerControl('facilityName', '', 'Required')}
                />
            </FormControlContainer>
                <FormControlContainer hasError={()=>errors.userType} label="User type" errorMessage={requiredMessage} id="userType">
                    <Select
                        {...props.registerControl('userType','','Required')}
                        required
                    >
                        <MenuItem value="">Select user type</MenuItem>
                        {lookUps.userTypes.map(x=><MenuItem key={x.code} value={x.code||''}>{x.name}</MenuItem>)}
                    </Select>
                </FormControlContainer>
        </>
    );
}